import { render, staticRenderFns } from "./VerifikasiUser.vue?vue&type=template&id=4502339e&"
import script from "./VerifikasiUser.vue?vue&type=script&lang=js&"
export * from "./VerifikasiUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports